module.exports = __webpack_public_path__ + "img/1724495749_application-3.35ff665b.png";